import React, { useState } from 'react';

const FeedbackSystem = () => {
  const [feedbacks, setFeedbacks] = useState([]);
  const [name, setName] = useState('');
  const [feedback, setFeedback] = useState('');
  const [rating, setRating] = useState(5);

  const submitFeedback = () => {
    setFeedbacks([...feedbacks, { name, feedback, rating }]);
    setName('');
    setFeedback('');
    setRating(5);
  };

  return (
    <div className="p-6 bg-white rounded-lg shadow-lg mb-6">
      <h2 className="text-3xl font-bold mb-4">Sistema de Feedback y Evaluaciones</h2>
      <input 
        type="text" 
        placeholder="Nombre" 
        value={name} 
        onChange={(e) => setName(e.target.value)} 
        className="w-full p-2 mb-2 border rounded" 
      />
      <textarea 
        placeholder="Deja tu comentario" 
        value={feedback} 
        onChange={(e) => setFeedback(e.target.value)} 
        className="w-full p-2 mb-2 border rounded" 
        rows="3"
      />
      <div className="flex mb-4">
        <span className="mr-2">Calificación:</span>
        <select value={rating} onChange={(e) => setRating(e.target.value)} className="border rounded">
          {[1, 2, 3, 4, 5].map(num => (
            <option key={num} value={num}>{num}</option>
          ))}
        </select>
      </div>
      <button onClick={submitFeedback} className="px-4 py-2 bg-blue-500 text-white rounded">Enviar Feedback</button>
      <ul className="mt-4">
        {feedbacks.map((f, index) => (
          <li key={index} className="border-b py-2">
            <strong>{f.name}</strong> - {f.feedback} - {f.rating} estrellas
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FeedbackSystem;
